//Global Imports
import React, { useState } from "react";
import clsx from "clsx";
import { Controller, useForm } from "react-hook-form";
//End Global Imports

//Local Imports
import Button from "../../../../components/ui/Button";
import Dropdown from "../../../../components/ui/Dropdown";
import Checkbox from "../../../../components/ui/Checkbox";
import TextFieldNew from "../../../../components/ui/TextField/TextFieldNew";
import Tooltip from "../../../../components/ui/Tooltip";
import { DoubleVerifiedIcon } from "../../../../assets/Icons";
import {
  getErrorMessage,
  regexForEmailAddress,
  regexForMobileNumber,
  regexForPassword,
  regexForSpecialChar,
} from "../../../../utils";
import { IStepOne } from "./StepOne";
import { sendOtp } from "../../../../services/auth";
import ErrorField from "../../../../components/ui/ErrorField";
//End Local Imports

const StepOneNew: React.FC<IStepOne.IProps> = ({
  countryCode,
  setActiveStep,
  saveUserData,
  saveCountryCode,
  setIsTermsModalOpen,
  userData,
}) => {
  const countryCodeDefaultValue = (
    <span className="flex items-center justify-start space-x-2 text-base font-medium text-black font-ssp">
      <img src={`/images/png/INR.png`} alt="" width="35px" height="35px" />
      <div>+91</div>
    </span>
  );

  const [isAgree, setIsAgree] = React.useState<boolean>(false);
  const [value, setValue] = React.useState(countryCodeDefaultValue);
  const [showDropdown, setShowDropdown] = React.useState<boolean>(false);
  const [signUpError, setSignUpError] = React.useState<string>("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");

  const coutryList = [
    {
      name: "United States +1",
      icon: "USD.png",
    },
    {
      name: "Canada +1",
      icon: "CAD.png",
    },
    {
      name: "India +91",
      icon: "INR.png",
    },
    {
      name: "United Kingdom +44",
      icon: "GBP.png",
    },
  ];

  const RadioLabel = (
    <div>
      <span className="pr-2 text-base lg:text-sm font-light text-[#000] font-inter">
        I agree to moneyHOP’s
      </span>
      <span
        className="text-base lg:text-sm font-normal cursor-pointer font-inter text-[#0F5BF1] underline"
        onClick={() => setIsTermsModalOpen(true)}
      >
        Terms & Conditions
      </span>
      {/* <span> & </span>
      <span
        className="text-xl font-normal cursor-pointer font-inter text-[#000] underline"
        onClick={() => setIsTermsModalOpen(true)}
      >
        the Privacy Policy.
      </span> */}
    </div>
  );

  const inputClass =
    "w-full flex !h-[40.104px] px-4 justify-between items-center self-stretch rounded-[12px] border border-[#D9D9D9]/100 border-[0.5px] !bg-[#fff] !text-[#000] !focus:bg-[#fff] !focus:text-[#000] !pt-0";

  const onSubmit = (data: any) => {
    saveUserData(data);
    sendOtp({
      body: {
        phoneNumber: countryCode + data.mobileNumber,
        otpType: "mobile",
        actionType: "SIGN_UP",
      },
      apiType: "send",
    })
      .then(() => setActiveStep(2))
      .catch((error) => {
        if (error?.response?.data?.error?.code === 2542) {
          setError("mobileNumber", {
            type: error?.response?.data?.error?.type,
          });
        } else {
          setSignUpError(error?.response?.data?.error?.type);
        }
      });
  };

  const PasswordValidator = ({ password, email }: { password: string; email: string }) => {
    // Validation checks
    const validations = [
      {
        label: "Should be min. 8 words",
        valid: password.length >= 8,
      },
      {
        label: "Should contain special characters",
        valid: /[!@#$%^&*(),.?":{}|<>]/.test(password),
      },
      {
        label: "Should not be same as email ID",
        valid: password && email && password != email,
      },
      {
        label: "Should contain atleast one uppercase letter",
        valid: /[A-Z]/.test(password),
      },
      {
        label: "Should contain atleast one lowercase letter",
        valid: /[a-z]/.test(password),
      },
    ];

    return (
      <div className="flex flex-wrap gap-2">
        {validations.map((rule, idx) => (
          <div
            key={idx}
            className={`flex items-center px-3 py-1 rounded-full text-sm lg:text-[10px] font-medium ${
              rule.valid ? "bg-green-700 text-white opacity-80" : "bg-red-700 text-white opacity-80"
            }`}
          >
            {rule.valid ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="8"
                viewBox="0 0 13 8"
                fill="#fff"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M2.85757 5.6415L8.49908 0L9.3576 0.858539L3.28684 6.92929C3.17299 7.04312 3.01858 7.1071 2.85757 7.1071C2.69656 7.1071 2.54215 7.04312 2.4283 6.92929L0 4.50099L0.858533 3.64246L2.85757 5.6415Z"
                  fill="#fff"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M6.50017 5.64155L12.1414 0L13 0.858514L6.9295 6.92928C6.69249 7.16634 6.30815 7.16634 6.07103 6.92934L5.16016 6.01873L6.01858 5.16008L6.50017 5.64155Z"
                  fill="#fff"
                />
              </svg>
            ) : (
              "✘"
            )}{" "}
            {rule.label}
          </div>
        ))}
      </div>
    );
  };

  type FormInputs = {
    email: string;
    password: string;
    confirmPassword: string;
    mobileNumber: number;
    vendorCode: string;
  };

  const {
    formState: { errors, isValid, isDirty },
    getValues,
    handleSubmit,
    setError,
    control,
  } = useForm<FormInputs>({ mode: "onChange" });

  return (
    <>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={`flex flex-col items-start xl:gap-3 w-full ${
          errors && Object.keys(errors).length > 0 ? "lg:gap-[6px]" : "lg:gap-3"
        }`}
        autoComplete="off"
      >
        <div className="flex flex-col items-start gap-2 mt-3 w-full lg:mt-1">
          <p className="xl:text-base lg:text-sm font-medium text-[#000] mb-1">
            Mobile Number <span className="text-red-100">*</span>
          </p>
          <div className=" flex items-start gap-3 w-full">
            <div className="flex py-[8px] px-[6px] w-[95px] gap-3 items-center rounded-xl border-[0.5px] border-[#D9D9D9] text-base font-medium text-[#000] bg-[#fff]">
              <img src={`/images/png/INR.png`} alt="" width="25px" height="25px" />
              <div>+91</div>
            </div>

            <div className="w-full">
              <Controller
                control={control}
                name="mobileNumber"
                rules={{ required: true, pattern: regexForMobileNumber }}
                render={({ field: { name, value, onChange } }) => {
                  return (
                    <TextFieldNew
                      name={name}
                      type="number"
                      placeholder="Enter your number"
                      inputClasses={inputClass}
                      placeholderStyle="text-[#9e9e9e] font-normal text-sm font-inter !top-[0.55rem]"
                      value={value}
                      // eslint-disable-next-line
                      errorMessage={getErrorMessage(
                        errors as Record<string, { type: any }>,
                        "mobileNumber",
                        "Mobile No."
                      )}
                      error={errors.mobileNumber}
                      onChange={(e) => {
                        const onlyDigits = e.target.value.replace(/\D/g, "");
                        if (onlyDigits.length <= 10) {
                          onChange(onlyDigits);
                        }
                      }}
                      // isValidate={
                      //   isDirty && !errors.mobileNumber && getValues("mobileNumber") !== undefined
                      // }
                      fullWidth
                      maxLength={10}
                      autoComplete="off"
                    />
                  );
                }}
              />
            </div>
          </div>
        </div>

        <div className="w-full">
          <Controller
            control={control}
            name="email"
            rules={{ required: true, pattern: regexForEmailAddress }}
            render={({ field: { name, value, onChange } }) => {
              return (
                <>
                  <p className="xl:text-base lg:text-sm font-medium text-[#000] mb-1">
                    Email <span className="text-red-100">*</span>
                  </p>
                  <TextFieldNew
                    name={name}
                    type="email"
                    placeholder="Enter your email"
                    inputClasses=" flex 
                    !h-[40.104px] 
                    px-4  
                    justify-between 
                    items-center 
                    self-stretch 
                    rounded-[12px] 
                    border border-[#D9D9D9]/100 border-[0.5px] 
                    bg-[#f5f5f5]/10
                    !text-[#000]
                    !pt-0"
                    placeholderStyle="text-[#9e9e9e] font-normal text-sm font-inter !top-[0.55rem]"
                    value={value}
                    errorMessage={getErrorMessage(
                      errors as Record<string, { type: any }>,
                      "email",
                      "Email"
                    )}
                    error={errors.email}
                    onChange={(v) => {
                      setEmail(v.target.value);
                      onChange(v);
                    }}
                    // isValidate={isDirty && !errors.email && getValues("email") !== undefined}
                    fullWidth
                    autoComplete="off"
                  />
                </>
              );
            }}
          />
        </div>

        <div className="w-full flex flex-col gap-2 items-start">
          <div className="flex items-start gap-7 w-full">
            <div className="w-full pb-7 sm:pb-0 px-6 sm:px-0">
              <Controller
                control={control}
                name="password"
                rules={{ required: true, pattern: regexForPassword }}
                render={({ field: { name, value, onChange } }) => {
                  return (
                    <>
                      <p className="xl:text-base lg:text-sm font-medium text-[#000] mb-1">
                        Password <span className="text-red-100">*</span>
                      </p>
                      <TextFieldNew
                        name={name}
                        type="password"
                        placeholder="Enter Password"
                        inputClasses={clsx(
                          errors?.password ? "border !text-[#000] !pt-0" : inputClass
                        )}
                        placeholderStyle="text-[#9e9e9e] font-normal text-sm font-inter !top-[0.55rem]"
                        value={value}
                        error={errors.password ? true : false}
                        // eslint-disable-next-line
                        errorMessage={getErrorMessage(
                          errors as Record<string, { type: any }>,
                          "password",
                          "Password"
                        )}
                        onChange={(v) => {
                          onChange(v);
                          setPassword(v.target.value);
                        }}
                        // isValidate={
                        //   isDirty && !errors.password && getValues("password") !== undefined
                        // }
                        fullWidth
                        containerStyle="!h-[36px]"
                        autoComplete="off"
                      />
                    </>
                  );
                }}
              />
            </div>
            <div className="w-full px-6 sm:px-0">
              <Controller
                control={control}
                name="confirmPassword"
                rules={{
                  required: true,
                  validate: {
                    sameAs: () => {
                      return getValues("password") === getValues("confirmPassword");
                    },
                  },
                }}
                render={({ field: { name, value, onChange } }) => {
                  return (
                    <>
                      <p className="xl:text-base lg:text-sm font-medium text-[#000] mb-1">
                        Confirm Password <span className="text-red-100">*</span>
                      </p>
                      <TextFieldNew
                        name={name}
                        type="password"
                        placeholder="Confirm Password"
                        inputClasses={clsx(
                          errors?.confirmPassword ? "border !text-[#000] !pt-0" : inputClass
                        )}
                        placeholderStyle="text-[#9e9e9e] font-normal text-sm font-inter !top-[0.55rem]"
                        value={value}
                        error={errors.confirmPassword}
                        // eslint-disable-next-line
                        errorMessage={getErrorMessage(
                          errors as Record<string, { type: any }>,
                          "confirmPassword",
                          "Confirm Password"
                        )}
                        onChange={(v) => onChange(v)}
                        fullWidth
                        containerStyle="!h-[36px]"
                        autoComplete="off"
                      />
                    </>
                  );
                }}
              />
            </div>
          </div>
          {errors.password && <PasswordValidator password={password} email={email} />}
        </div>

        <div className="w-full px-6 sm:px-0">
          <Controller
            control={control}
            name="vendorCode"
            rules={{ required: true, pattern: regexForSpecialChar }}
            render={({ field: { name, value, onChange } }) => {
              return (
                <>
                  <p className="xl:text-base lg:text-sm font-medium text-[#000] mb-1">
                    Enter vendor code <span className="text-red-100">*</span>
                  </p>
                  <TextFieldNew
                    name={name}
                    type="text"
                    placeholder="Enter Vendor Code"
                    inputClasses={clsx(
                      errors?.vendorCode ? "border !pt-0 !h-[40.104px]" : inputClass
                    )}
                    placeholderStyle="text-[#9e9e9e] font-normal text-sm font-inter !top-[0.55rem] !pt-0"
                    value={value ?? ""}
                    error={errors.vendorCode}
                    // eslint-disable-next-line
                    errorMessage={getErrorMessage(
                      errors as Record<string, { type: any }>,
                      "vendorCode",
                      "Vendor"
                    )}
                    onChange={(v) => onChange(v)}
                    fullWidth
                  />
                </>
              );
            }}
          />
        </div>

        <div className="w-full">
          <Checkbox
            label={RadioLabel}
            value={isAgree ? "true" : "false"}
            name="isAgreeTermsAndConditions"
            rootclassName="rounded-full !w-4 !h-4 !border-secondary-600"
            checkboxClassname="rounded-full xl:w-2 lg:w-2 lg:h-2 xl:h-2"
            labelClassName="cursor-pointer !text-[#0F5BF1] text-sm"
            handleChange={(e) => {
              setIsAgree(e.target.checked);
            }}
          />
        </div>

        <Button
          bgColor={`${isValid && isAgree ? "bg-primary-1050" : "bg-primary-1050"}`}
          fontStyle={{
            fontFamily: "font-inter",
            fontSize: "xl:text-lg lg:text-base",
            fontWeight: "font-semibold",
            fontColor: "text-white",
          }}
          borderStyle={{
            borderWidth: "border-none",
            borderRadius: "rounded",
          }}
          className="w-full xl:h-[46px] lg:h-[36px] disabled:opacity-50 disabled:cursor-not-allowed xl:mt-3 lg:mt-0"
          disabled={!isValid || !isAgree}
        >
          Verify
        </Button>

        {signUpError && <ErrorField errorMessage={signUpError} errorClassname="self-center" />}
      </form>
    </>
  );
};

export default StepOneNew;
